import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DraftSheetPage from './DraftSheetPage';
import DraftPage from './DraftPage';
import { supabase } from '../services/supabase';

export default function DraftSheetPageWrapper() {
  const { leagueId } = useParams<{ leagueId: string }>();
  const navigate = useNavigate();
  const [teamId, setTeamId] = React.useState<string>('');
  const [leagueStatus, setLeagueStatus] = React.useState<string>('');
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const load = async () => {
      const userId = localStorage.getItem('userId');
      if (userId && leagueId) {
        const { data } = await supabase
          .from('teams')
          .select('id')
          .eq('league_id', leagueId)
          .eq('owner_id', userId)
          .single();
        if (data) setTeamId(data.id);

        const { data: league } = await supabase
          .from('leagues')
          .select('status')
          .eq('id', leagueId)
          .single();
        if (league) setLeagueStatus(league.status);
      }
      setLoading(false);
    };
    load();
  }, [leagueId]);

  if (loading) return <div style={{padding:40,textAlign:'center',color:'#666'}}>Loading...</div>;
  if (!leagueId) return <div style={{padding:40,textAlign:'center',color:'#666'}}>League not found.</div>;

  // Draft not started yet (waiting/creating)
  if (leagueStatus === 'waiting' || leagueStatus === 'creating') {
    return (
      <div style={{padding:40,textAlign:'center'}}>
        <h2 style={{color:'#fff',marginBottom:12}}>🔒 Draft Not Started Yet</h2>
        <p style={{color:'#9ca3af',marginBottom:20}}>The draft priority sheet becomes available once 8+ owners have joined and the 15-minute clock starts. Everyone gets the same window — no early access!</p>
        <button onClick={() => navigate(`/league/${leagueId}`)}
          style={{padding:'10px 24px',borderRadius:8,border:'none',background:'#3b82f6',color:'#fff',cursor:'pointer',fontSize:'1rem'}}>
          Back to League
        </button>
      </div>
    );
  }

  // Live draft in progress
  if (leagueStatus === 'drafting') {
    return (
      <DraftSheetPage
        leagueId={leagueId}
        teamId={teamId || ''}
        onBack={() => navigate(-1)}
        onNavigate={(route) => navigate(route)}
      />
    );
  }

  // Draft complete — show results (active, playoffs, completed)
  return <DraftPage leagueId={leagueId} userId={localStorage.getItem('userId') || ''} teamId={teamId || ''} />;
}
